export enum GooddayApp  {
    UNKNOWN                     = 'unknown-app',

    MY_TASKS                    = 'my-work-tasks',
    NOTEPAD                     = 'notepad',
    RECENT                      = 'view-recent',
    MY_MEETINGS                 = 'view-my-meetings',
    MY_WORKLOAD                 = 'view-my-workload',
    MY_DOCUMENTS                = 'my-documents',
    MY_CALENDAR                 = 'my-calendar',
    MY_TIME                     = 'app-my-time',
    EVENTS_SUMMARY              = 'view-my-events-summary',
    GOALS                       = 'view-goals',
    MY_ATTENDANCE               = 'my-attendance',


    SETTINGS_ORGANIZAITON       = "organization-settings-generic",      // used when no specific app is specified
    SETTINGS_GOOGLE_DRIVE       = 'organization-settings-google-drive',

    CUSTOM_VIEW_BOARD           = 'custom-view-board',
    CUSTOM_VIEW_TABLE           = 'custom-view-table',
    CUSTOM_VIEW_LIST            = 'custom-view-list',
    CUSTOM_VIEW_GANTT           = 'custom-view-gantt',
    CUSTOM_VIEW_WORKLOAD        = 'custom-view-workload',
    CUSTOM_VIEW_CALENDAR        = 'custom-view-calendar',
    CUSTOM_VIEW_DASHBOARD       = 'custom-view-dashboard',
    CUSTOM_VIEW_EXPENSES        = 'custom-view-expenses',
    CUSTOM_VIEW_PROJECTS_TABLE  = 'custom-view-projects-table',
    CUSTOM_VIEW_ACTIVITY        = 'custom-view-activity',
    CUSTOM_VIEW_PAST_DUE        = 'custom-view-past-due',
    CUSTOM_VIEW_PRIORITIES      = 'custom-view-priorities',

    CUSTOM_VIEW_EXTERNAL_LIST   = 'custom-view-external-list',

    PROJECT_TABLE               = 'project-table',
    PROJECT_LIST                = 'project-list',
    PROJECT_BOARD               = 'project-board',
    PROJECT_GOALS               = 'project-goals',
    PROJECT_EXPENSES            = 'project-expenses',
    PROJECT_PAGE                = 'project-page',
    PROJECT_EMBED               = 'project-embed',
    PROJECT_LINK                = 'project-link',
    PROJECT_REPORTS             = 'project-reports',
    PROJECT_WORKLOAD            = 'project-workload',
    PROJECT_DASHBOARD           = 'project-dashboard',
    PROJECT_CALENDAR            = 'project-calendar',
    PROJECT_DOCS                = 'project-docs',
    PROJECT_ACTIVITY            = 'project-activity',
    PROJECT_MEETINGS            = 'project-meetings',
    PROJECT_GANTT               = 'project-gantt',
    PROJECT_FILES               = 'project-files',
    PROJECT_DISCUSSION          = 'project-discussion',

    PROJECTS_PORTFOLIO          = 'projects-portfolio',
    PORTFOLIO_TABLE             = 'portfolio-table',
    PORTFOLIO_LIST              = 'portfolio-list',

    CUSTOM_VIEW_REPORT          = "custom-view-report",
}
